module.exports = __webpack_public_path__ + "media/packs/images/flags/IQ-9dbc38bcd16a2cdb245c7c5c2645b661.png";